import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import domToImage from 'dom-to-image';

export const WHEEL_IMAGE_FILE_PREFIX = 'WheelOfLife';

@Injectable({ providedIn: 'root' })
export class ImageDownloadService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);

  public async downloadWheelImage(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;

    const printOnly = this.document.getElementById('print-only');
    const wrapperToImage = this.document.getElementById('main-container');
    if (!wrapperToImage) return;

    const link = this.document.createElement('a');
    link.download = this.createDownloadFileName();
    const previousPrintOnlyVisibility = printOnly?.style.visibility;

    try {
      if (printOnly) printOnly.style.visibility = 'visible';

      link.href = await domToImage.toJpeg(wrapperToImage, { bgcolor: 'white', quality: 0.95 });
      link.click();
    } finally {
      if (printOnly) printOnly.style.visibility = previousPrintOnlyVisibility ?? '';
    }
  }

  private createDownloadFileName(): string {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);

    return `${WHEEL_IMAGE_FILE_PREFIX}-${day}-${month}-${year}.jpg`;
  }
}
